import { ProductProps } from '../../type'
import { ProductCategory, ProductTag } from '../../enum'
import imageBanner from './img/banner.png'
import imageTable from './img/table.jpg'

export const mobileEnergyStorageVehicle: ProductProps = {
  tag: ProductTag.ESS,
  category: ProductCategory.SpecialtyMobilePowerSystems,
  pathName: 'mobile-energy-storage-vehicle',
  banner: imageBanner,
  title: 'Mobile Energy Storage Vehicle',
  description:
    'Our products are positioned in off-grid mobile energystorage vehicles.\nThe overall height is reduced (controlled within 2.5 meters), which is suitable for transportation of vehicles with traction\nforce of more than 28T. At the same time, the center of gravity of the installation is lowered, and the stability is also enhanced.',
  specImages: [imageTable],
}
